import React from 'react';
import ElementDataSection from 'components/common/element-data/ElementDataSection';
import CurrentValue from 'components/common/element-data/parts/CurrentValue';
import { ElementMetadataSectionName, IElementDataSectionSummary } from 'components/common/element-data/types';
import ComparisonInfo from 'components/common/element-data/parts/ComparisonInfo';
import MovingAverage from 'components/common/element-data/parts/MovingAverage';
import MinimumEver from 'components/common/element-data/parts/MinimumEver';
import MaximumEver from 'components/common/element-data/parts/MaximumEver';
import Description from 'components/common/element-data/parts/Description';
import Certification from 'components/common/element-data/parts/Certification';
import useBundleTranslation from 'i18n';
import { getSectionElementMetadataSettings } from 'components/common/element-data/functions';

export default function SummarySection(props: IElementDataSectionSummary) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { settings, ...element } = props;
    const sectionKey: ElementMetadataSectionName = 'summary';
    const { sectionMetadataOrder } = getSectionElementMetadataSettings(settings, sectionKey);

    return (
        <ElementDataSection title={t(`element_data_section_label.${sectionKey}`)} order={sectionMetadataOrder}>
            <Certification {...element} settings={settings} />
            <Description {...element} settings={settings} />
            <CurrentValue {...element} settings={settings} />
            <ComparisonInfo {...element} settings={settings} />
            <MovingAverage {...element} settings={settings} />
            <MinimumEver {...element} settings={settings} />
            <MaximumEver {...element} settings={settings} />
        </ElementDataSection>
    );
}
